module.exports = __webpack_public_path__ + "static/img/io.3ddd1280.svg";